// src/client/routes.tsx
// Route tree:
//   /              SplashScreen (decides where to send the user)
//   /login         LoginScreen (signed_out only)
//   /kyc          KYCScreen (signed_in but kyc !== verified)
//   <ProtectedRoute>
//     <KycGuard>
//       <AppNavigator>     // overlays floating NavBar
//         /home          HomeScreen
//         /loan/apply    LoanApplyScreen
//         /loan/confirm  LoanConfirmScreen
//         /loan/success  LoanSuccessScreen
//         /loans         LoansListScreen
//         /repay         RepayScreen
//         /profile       ProfileScreen
//       </AppNavigator>
//     </KycGuard>
//   </ProtectedRoute>
import { Routes, Route, Navigate } from 'react-router-dom';
import { ROUTES } from '@/constants/routes';
import { ProtectedRoute } from '@client/auth/ProtectedRoute';
import { KycGuard } from '@client/auth/KycGuard';
import AppNavigator from '@client/navigation/AppNavigator';
import SplashScreen from '@client/screens/auth/SplashScreen';
import LoginScreen from '@client/screens/auth/LoginScreen';
import KYCScreen from '@client/screens/auth/KYCScreen';
import HomeScreen from '@client/screens/borrower/HomeScreen';
import LoanApplyScreen from '@client/screens/borrower/LoanApplyScreen';
import LoanConfirmScreen from '@client/screens/borrower/LoanConfirmScreen';
import LoanSuccessScreen from '@client/screens/borrower/LoanSuccessScreen';
import LoansListScreen from '@client/screens/borrower/LoansListScreen';
import RepayScreen from '@client/screens/borrower/RepayScreen';
import ProfileScreen from '@client/screens/borrower/ProfileScreen';
import CreditScoreScreen from '@client/screens/borrower/CreditScoreScreen';
import LoanDetailScreen from '@client/screens/borrower/LoanDetailScreen';
import SettingsScreen from '@client/screens/borrower/SettingsScreen';

export function AppRoutes() {
  return (
    <Routes>
      <Route path={ROUTES.splash} element={<SplashScreen />} />
      <Route path={ROUTES.login} element={<LoginScreen />} />
      <Route element={<ProtectedRoute />}>
        <Route path={ROUTES.kyc} element={<KYCScreen />} />
        <Route element={<KycGuard />}>
          <Route element={<AppNavigator />}>
            <Route path={ROUTES.home} element={<HomeScreen />} />
            <Route path={ROUTES.loanApply} element={<LoanApplyScreen />} />
            <Route path={ROUTES.loanConfirm} element={<LoanConfirmScreen />} />
            <Route path={ROUTES.loanSuccess} element={<LoanSuccessScreen />} />
            <Route path={ROUTES.loansList} element={<LoansListScreen />} />
            <Route path={ROUTES.loanDetail} element={<LoanDetailScreen />} />
            <Route path={ROUTES.score} element={<CreditScoreScreen />} />
            <Route path={ROUTES.repay} element={<RepayScreen />} />
            <Route path={ROUTES.profile} element={<ProfileScreen />} />
            <Route path={ROUTES.settings} element={<SettingsScreen />} />
          </Route>
        </Route>
      </Route>
      <Route path="*" element={<Navigate to={ROUTES.splash} replace />} />
    </Routes>
  );
}
